import s from "./generateUtilityClasses.mjs";
const t = s("MuiDialogTitle", ["root"]), l = t;
export {
  l as default
};
//# sourceMappingURL=dialogTitleClasses.mjs.map
